import { render } from "./TabulaRasa.vue?vue&type=template&id=602e17a5"
import script from "./TabulaRasa.vue?vue&type=script&lang=js"
export * from "./TabulaRasa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__